export default __webpack_public_path__ + "static/media/lifong01.c876ed2f.png";